import React from "react";

export const TESTIMONIALS = {
  ashley: {
    color: "#33D1FF",
    profileImage: "https://images.domain.com.au/img/26285/contact_1265447.jpeg?buster=2025-04-16",
    logo: "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/point-residential-26285-1265447/logo_url_1775717056_a2d6a92d.jpg",
    name: "Ashley Quinn",
    title: "Licensed Agent",
    agency: "Point Residential Real Estate",
    eyebrow: "What Agents Say",
    heading: "Real results from real agents",
    snippet: "My involvement is minimal as it all happens in the background.",
    pills: [
      "Set & forget",
      "Custom owner reports",
      "No spammy emails",
      "AI-powered",
    ],
    quote: `I started using Vendorleads about 1 month ago. Like many agents I have 1000's of residents details that I just don't get in contact with. I didn't want to send out random "just sold" or free market appraisal emails so the idea of individual customised reports on an owners property sent automatically and addressed from me appealed. My involvement is minimal as it all happens in the background. I have the option of adding feedback to a report only after an owner has expressed interest in their report, so I'm not wasting time on reports that are never opened.\n\nAI is new to me so it was about time my business moved with the times and Vendorleads has proved an economical and productive way of doing it.`,
  },
  liam: {
    color: "#ee7026",
    profileImage: "https://images.domain.com.au/img/7270/contact_1860786.jpeg?buster=2025-04-17",
    logo: "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/domain-illawarra-real-estate-7270-1597569/domain-illawarra-logo.png",
    logoBackground: "#fff",
    name: "Liam McKern",
    title: "Licensed Agent",
    agency: "Domain Illawarra Real Estate",
    eyebrow: "Marketing on Autopilot",
    heading: "More listings, none of the marketing grind",
    snippet: "It's like having a dedicated marketing team, without the overhead or stress.",
    pills: [
      "Quarterly SMS",
      "AI articles in his name",
      "Compounds over time",
      "Listing conversations",
    ],
    quote: `Between opens, inspections, and everything else that comes with the job, finding time to run consistent marketing is a real challenge. Vendorleads solves that completely. SMS campaigns go out every quarter, articles get published under my name, emails reach the right people, all without pulling me away from what I do best.\n\nWhat surprised me most was how much it compounds over time. Every month more people are engaging with the content, and I've had vendors mention an article of mine they read months ago that I didn't have to write, which is exactly the kind of touchpoint that leads to a listing conversation.\n\nIt's like having a dedicated marketing team, without the overhead or stress.`,
  },
  barbara: {
    color: "#04afa9",
    profileImage: "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/dwell-realty-28415-1486452/dwell_profile.png",
    logo: "https://realestate-reports-assets.s3.us-west-2.amazonaws.com/agencies/dwell-realty-28415-1486452/dwell_realty_logo.jpg",
    logoBackground: "#fff",
    name: "Barbara",
    title: "Principal",
    agency: "Dwell Realty",
    eyebrow: "Perfect Timing",
    heading: "Knowing exactly when to pick up the phone",
    snippet: "I just step in when Vendorleads tells me they're warm.",
    pills: [
      "Database on autopilot",
      "Live engagement pings",
      "Reconnecting old contacts",
      "No chasing",
    ],
    quote: `Vendorleads basically runs my database for me. The property reports go out every month and I don't have to touch any of it.\n\nThe notifications are what changed things. When someone opens their report a few times or jumps on to value their property, I get a ping and I know that's my moment to call. It's started real conversations with people I hadn't spoken to in years.\n\nI'm not chasing anyone. I just step in when Vendorleads tells me they're warm.`,
  },
};

function getInitials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export default function TestimonialSection({ isMobile, testimonial = "ashley", showHeading = true }) {
  const data = TESTIMONIALS[testimonial] || TESTIMONIALS.ashley;
  const {
    color: AGENT_COLOR,
    profileImage: AGENT_PROFILE_IMAGE,
    logo: AGENT_LOGO,
    logoBackground,
    name: AGENT_NAME,
    title: AGENT_TITLE,
    agency: AGENCY_NAME,
    eyebrow: EYEBROW = "What Agents Say",
    heading: HEADING = "Real results from real agents",
    pills: PILLS = [],
    quote: QUOTE,
  } = data;

  return (
    <section
      style={{
        padding: isMobile ? "3.5rem 1.5rem" : "5rem 2rem",
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #134e4a 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Grid overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
          pointerEvents: "none",
        }}
      />

      <div style={{ maxWidth: "800px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        {/* Section heading */}
        {showHeading && (
          <div style={{ textAlign: "center", marginBottom: isMobile ? "2rem" : "2.5rem" }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "0.5rem",
                background: `${AGENT_COLOR}20`,
                border: `1px solid ${AGENT_COLOR}40`,
                color: AGENT_COLOR,
                fontSize: "0.78rem",
                fontWeight: 700,
                borderRadius: "6px",
                padding: "0.3rem 0.75rem",
                marginBottom: "1rem",
                letterSpacing: "0.04em",
                textTransform: "uppercase",
              }}
            >
              {EYEBROW}
            </div>
            <h2
              style={{
                fontSize: isMobile ? "1.6rem" : "2.2rem",
                fontWeight: 800,
                color: "#fff",
                lineHeight: 1.2,
                letterSpacing: "-0.02em",
                margin: 0,
              }}
            >
              {HEADING}
            </h2>
          </div>
        )}

        {/* Testimonial card */}
        <div
          style={{
            background: "rgba(255,255,255,0.06)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "20px",
            padding: isMobile ? "2rem 1.5rem" : "2.5rem 3rem",
            position: "relative",
          }}
        >
          {/* Accent top border */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: "2rem",
              right: "2rem",
              height: "3px",
              borderRadius: "0 0 3px 3px",
              background: `linear-gradient(90deg, ${AGENT_COLOR}, #10b981)`,
            }}
          />

          {/* Large open-quote */}
          <div
            style={{
              fontSize: "4rem",
              lineHeight: 1,
              color: AGENT_COLOR,
              opacity: 0.3,
              fontFamily: "Georgia, serif",
              marginBottom: "-1rem",
              userSelect: "none",
            }}
          >
            &ldquo;
          </div>

          {/* Quote text */}
          <p
            style={{
              color: "rgba(255,255,255,0.85)",
              fontSize: isMobile ? "0.95rem" : "1.05rem",
              lineHeight: 1.8,
              margin: "0 0 2rem 0",
              fontStyle: "italic",
              whiteSpace: "pre-line",
            }}
          >
            {QUOTE}
          </p>

          {/* Key positives - pills */}
          {PILLS && PILLS.length > 0 && (
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "0.5rem",
                marginBottom: "1.75rem",
              }}
            >
              {PILLS.map((pill) => (
                <span
                  key={pill}
                  style={{
                    background: `${AGENT_COLOR}1F`,
                    color: AGENT_COLOR,
                    border: `1px solid ${AGENT_COLOR}55`,
                    fontSize: "0.78rem",
                    fontWeight: 600,
                    borderRadius: "999px",
                    padding: "0.3rem 0.8rem",
                    whiteSpace: "nowrap",
                  }}
                >
                  {pill}
                </span>
              ))}
            </div>
          )}

          {/* Agent info row */}
          <div
            style={{
              display: "flex",
              alignItems: isMobile ? "flex-start" : "center",
              gap: "1rem",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
            }}
          >
            {/* Left: profile + details */}
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              {/* Profile image or initials fallback */}
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: `3px solid ${AGENT_COLOR}`,
                  flexShrink: 0,
                  boxShadow: `0 0 16px ${AGENT_COLOR}30`,
                  background: AGENT_PROFILE_IMAGE ? "transparent" : `${AGENT_COLOR}25`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "1.05rem",
                  letterSpacing: "0.02em",
                }}
              >
                {AGENT_PROFILE_IMAGE ? (
                  <img
                    src={AGENT_PROFILE_IMAGE}
                    alt={AGENT_NAME}
                    style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                  />
                ) : (
                  getInitials(AGENT_NAME)
                )}
              </div>
              {/* Name & title */}
              <div>
                <div style={{ color: "#fff", fontWeight: 700, fontSize: "1rem", marginBottom: "0.15rem" }}>
                  {AGENT_NAME}
                </div>
                <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.85rem" }}>
                  {AGENT_TITLE}
                </div>
                <div style={{ color: AGENT_COLOR, fontSize: "0.8rem", fontWeight: 600, marginTop: "0.1rem" }}>
                  {AGENCY_NAME}
                </div>
              </div>
            </div>

            {/* Right: agency logo */}
            <div
              style={{
                background: logoBackground || AGENT_COLOR,
                borderRadius: "10px",
                padding: "0.6rem 1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: `0 4px 16px ${AGENT_COLOR}40`,
              }}
            >
              <img
                src={AGENT_LOGO}
                alt={AGENCY_NAME}
                style={{
                  height: "36px",
                  maxWidth: "160px",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
